var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-wrapper add-customer-section"},[_c('ProductDetail',{ref:"CustomerDetail",attrs:{"productData":_vm.productData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }